import type { HtmlFieldType } from '@Types/GF/Fields';

import parse from 'html-react-parser';

type Props = {
	field: HtmlFieldType;
};

export default function HtmlField({ field }: Props) {
	const { type, cssClass, content: rawContent } = field;

	const content = rawContent ? parse(rawContent) : '';

	return <div className={`mb-5 gfield gfield-${type} ${cssClass}`.trim()}>{content}</div>;
}
